import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DatePipe } from '@angular/common';
import { InputNumberModule } from 'primeng/inputnumber';
import { CodeDialogComponent } from "./dialogs/code-dialog/code-dialog.component";
import { MembershipCodesService } from './services/membership-codes.service';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MainLayoutComponent } from '../layouts/main-layout/main-layout.component';

@Component({
  selector: 'app-codes',
  standalone: true,
  imports: [TableModule, ButtonModule, MenuModule, InputNumberModule, CodeDialogComponent, ToastModule, DatePipe, ConfirmDialogModule],
  templateUrl: './codes.component.html',
  styleUrl: './codes.component.scss',
  providers: [MessageService, ConfirmationService]
})
export class CodesComponent implements OnInit {
  isDialogVisible = false;
  codes: any[] | undefined;
  isLoading = false;
  items: MenuItem[] | undefined;
  // private supabase: SupabaseClient;
  selectedCode: any;
  isEdit = false;
  constructor(private membershipCodesService: MembershipCodesService, private messageService: MessageService, private layoutComponent: MainLayoutComponent, private confirmationService: ConfirmationService) {
      // this.supabase = this.authService.supabase;
  }

  closeDialog(cancel: boolean) {
    if(!cancel) {
        if(this.isEdit) {
            this.messageService.add({ severity: 'info', summary: 'Updated', detail: 'Access code is edited'  });
        }else {
            this.messageService.add({ severity: 'info', summary: 'Created', detail: 'Access code is created'  });
        }
    }
    this.isDialogVisible = false;
    this.selectedCode = undefined;
    this.isEdit = false;

    this.layoutComponent.navbarTitle = 'Access Code';
    this.getCodes();
}
  async ngOnInit() {
    this.items = [
      {
          label: 'Edit',
          command: (e) => {
            this.isEdit = true;
            this.isDialogVisible = true;
            this.layoutComponent.navbarTitle = "Edit code";
          } 
      },
      {
          label: 'Delete',
          styleClass: 'warning',
          command: (e) => {
            this.deleteCode(this.selectedCode.id)
          } 
      }
    ]
    await this.getCodes()
  }

  async getCodes() {
    this.isLoading = true;
    try {
      this.codes = await this.membershipCodesService.getAllCodes().toPromise();
      this.isLoading = false;
    } catch (error) {
      console.log('++++++ error' + Date.now(), error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error loading access codes' });
      this.isLoading = false;
    }
          
  }
  copy(text: string) {
    navigator.clipboard.writeText(text);
    this.messageService.add({ severity: 'contrast', summary: 'Copied', detail: 'Access code is copied to clipboard',  });
  }

  async deleteCode(id: string) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this access code?',
      header: 'Delete Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: async () => {
        try {
          await this.membershipCodesService.deleteCode(id).toPromise();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Access code deleted successfully' });
          this.getCodes();
        } catch (error) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error deleting access code' });
        }
        this.selectedCode = undefined;
      }
    });
  }

  openNewCodeDialog() {
    this.layoutComponent.navbarTitle = "New code";
    this.isDialogVisible=true
  }
}
